import React from "react";
import { Link } from 'gatsby';
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import { MdAdd, MdRemove, MdFullscreen, MdLocationOn } from 'react-icons/md';
import { Container, Tools, Post, Location } from './styles';
import preferredRoute from "../../assets/misc/preferred-route.jpg";

export default function Project() {
  const locations = [
    { top: "calc(29.64% - 27px)", left: "calc(13.17% - 15px)", url: "/the-project#m6-junction-40-to-kemplay-bank" },
    { top: "calc(30.13% - 27px)", left: "calc(18.23% - 15px)", url: "/the-project#penrith-to-temple-sowerby" },
    { top: "calc(39.58% - 27px)", left: "calc(25.73% - 15px)", url: "/the-project#temple-sowerby-to-appleby" },
    { top: "calc(51.53% - 27px)", left: "calc(36.93% - 15px)", url: "/the-project#appleby-to-brough" },
    { top: "calc(55.49% - 27px)", left: "calc(62.03% - 15px)", url: "/the-project#bowes-bypass" },
    { top: "calc(54.85% - 27px)", left: "calc(69.01% - 15px)", url: "/the-project#cross-lanes-to-rokeby" },
    { top: "calc(61.39% - 27px)", left: "calc(76.67% - 15px)", url: "/the-project#stephen-bank-to-carkin-moor" },
    { top: "calc(67.61% - 27px)", left: "calc(86.30% - 15px)", url: "/the-project#a1m-junction-53-scotch-corner" },
  ]

  return (
    <Container>
      <TransformWrapper>
        {({ zoomIn, zoomOut, resetTransform, ...rest }) => (
          <>
            <Tools>
              <Post>
                <button onClick={() => zoomIn()}><MdAdd /></button>
              </Post>
              <Post>
                <button onClick={() => zoomOut()}><MdRemove /></button>
              </Post>
              <Post>
                <button onClick={() => resetTransform()}><MdFullscreen /></button>
              </Post>
            </Tools>
            <TransformComponent>
              <img src={preferredRoute} alt="Preferred Route" />
              {locations.map(({ top, left, url }) => (
                <Location key={url}>
                  <Link to={url}>
                    <MdLocationOn style={{ position: "absolute", top: top, left: left }}/>
                  </Link>
                </Location>
              ))}
            </TransformComponent>
          </>
        )}
      </TransformWrapper>
    </Container>
  )
}